import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Header,
  Form,
  Segment,
  Table,
  Checkbox,
  Button,
  Progress,
} from 'semantic-ui-react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useStore } from '../../app/stores/store';
import PivotSmallModal from './PivotSmallModal';
import PivotTablejs from './PivotTablejs';
import DatePicker from 'react-datepicker';
import moment from 'moment';

function SaveAsPivot() {
  const history = useNavigate();
  const { PivotStore, userStore } = useStore();
  const { id } = useParams<{ id: string }>();
  const [changeDate, setChangeDate] = useState(false);
  const {
    loadPivotReportkeys2,
    getSingleSaveAsPivot,
    increaseCount,
    totalPivotCount,
    getPivotReportKeys2,
    setChosenMetaData2,
    saveChosenPivotData2,
    mainPivotData2,
    showPivotReport2,
    pivotReportModal,
    loadCheckBox,
    loadPivotTable,
    setPivotRowandColumn2,
    singleSaveAsPivot,
    pivotRow2,
    pivotColumn2,
    pivotReportKeysSingle,
    chosenPivotReportKeysSingle,
  } = PivotStore;
  const [pivotKeysData, setPivotKeysData] = useState<string[]>([]);
  const [startDate, setStateDate] = useState('');
  const [endDate, setendDate] = useState('');

  useEffect(
    () => {
      if (id) getSingleSaveAsPivot(id);
    },
    // eslint-disable-next-line
    [id],
  );

  useEffect(() => {
    setStateDate(singleSaveAsPivot?.start!);
    setendDate(singleSaveAsPivot?.end!);
    // eslint-disable-next-line
  }, [singleSaveAsPivot]);

  useEffect(() => {
    if (PivotStore?.singleSaveAsPivot) {
      PivotStore.singleSaveAsPivot.start = PivotStore.dateFormat(startDate);
      PivotStore.singleSaveAsPivot.end = PivotStore.dateFormat(endDate);
    }
    if (startDate !== '' && endDate !== '' && changeDate) {
      loadPivotReportkeys2(
        PivotStore.dateFormat(startDate),
        PivotStore.dateFormat(endDate),
      );
    }
    // eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    setPivotKeysData(getPivotReportKeys2);
  }, [getPivotReportKeys2]);

  //  const ChangeDateFunc=(data:any)=>{

  //   if(data !==""){
  //     let replaceDate:string[]=data.split("-");

  //     let replaceDate2=replaceDate[2]+"-"+replaceDate[1]+"-"+replaceDate[0]

  //     return replaceDate2;
  //   }else{
  //     return ""
  //   }
  // }
  const setDate = (data: any, type: string) => {
    // var dateString = data;
    // var startDate = new Date(dateString);
    // // seconds * minutes * hours * milliseconds = 1 day
    // var day = 60 * 60 * 24 * 1000;

    // var endDate = new Date(startDate.getTime() + day).toISOString();
    if (type === 'start') {
      setStateDate(data);
      setChangeDate(true);
    } else {
      setChangeDate(true);
      setendDate(data);
    }
  };
  if (loadCheckBox || loadPivotTable)
    return (
      <Segment style={{ margin: '27rem 27rem 0rem 27rem' }}>
        <Progress
          indicating
          style={{ marginTop: '20px' }}
          value={increaseCount}
          total={totalPivotCount}
        >
          Loading Your Data ...{' '}
        </Progress>{' '}
      </Segment>
    );

  if (!singleSaveAsPivot || !mainPivotData2) return <LoadingComponent />;

  return (
    <div style={{ padding: '1px' }}>
      {pivotReportModal && (
        <PivotSmallModal startDate={startDate} endDate={endDate} />
      )}
      <Header
        style={{ marginLeft: '20px' }}
        icon="cogs"
        size="huge"
        dividing
        as="h1"
        content={singleSaveAsPivot.tableName}
        sub
        color="grey"
      />
      <h1 style={{ marginLeft: '20px', marginTop: '20px' }}>
        Choose From and To Date
      </h1>
      <div style={{ display: 'flex', marginTop: '10px' }}>
        {!showPivotReport2 && pivotReportKeysSingle.length > 0 && (
          <Button
            primary
            onClick={() =>
              saveChosenPivotData2(
                PivotStore.dateFormat(startDate),
                PivotStore.dateFormat(endDate),
              )
            }
            style={{ position: 'absolute', right: '40px' }}
          >
            Submit
          </Button>
        )}
        <Form.Field required={true}>
          <label style={{ marginLeft: '90px' }}>
            <b>From</b>
          </label>
          <br />
          <div style={{ position: 'relative' }}>
            <DatePicker
              value={startDate ? PivotStore.dateFormat(startDate) : ''}
              showMonthDropdown
              showYearDropdown
              dateFormatCalendar="MMMM"
              locale={'en'}
              className="date-picker-style"
              yearDropdownItemNumber={15}
              maxDate={moment().toDate()}
              scrollableYearDropdown
              onChange={(date: any) => setDate(date, 'start')}
              popperProps={{ strategy: 'fixed' }}
            />
          </div>
        </Form.Field>
        <Form.Field required={true}>
          <label style={{ marginLeft: '100px' }}>
            <b>To</b>
          </label>
          <br />
          <div style={{ position: 'relative' }}>
            <DatePicker
              value={PivotStore.dateFormat(new Date().toLocaleDateString('en'))}
              showMonthDropdown
              showYearDropdown
              dateFormatCalendar="MMMM"
              className="date-picker-style"
              yearDropdownItemNumber={15}
              locale={'en'}
              minDate={new Date()}
              maxDate={moment().toDate()}
              scrollableYearDropdown
              onChange={(date: any) => setDate(date, 'end')}
              popperProps={{ strategy: 'fixed' }}
            />
          </div>
        </Form.Field>
      </div>
      {!showPivotReport2 && pivotReportKeysSingle.length > 0 && (
        <Segment style={{ margin: '16px 20px' }}>
          <Segment style={{ height: '47rem', overflowY: 'scroll' }}>
            <Table basic>
              <Table.Body>
                {pivotKeysData?.map((label) => {
                  return (
                    <Table.Row>
                      <Table.Cell>
                        <Checkbox
                          label={label}
                          key={label}
                          defaultChecked={
                            chosenPivotReportKeysSingle.includes(label)
                              ? true
                              : false
                          }
                          onChange={(e, data) => setChosenMetaData2(data)}
                        />
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </Segment>
        </Segment>
      )}
      {showPivotReport2 && (
        <>
          <Button.Group floated="right" style={{ marginTop: '-5rem' }}>
            <Button
              positive
              onClick={() =>
                PivotStore.updateUserSaveAsPivotData(singleSaveAsPivot)
              }
            >
              Update
            </Button>
            <Button.Or />
            <Button
              negative
              onClick={() => {
                PivotStore.deleteUserData(singleSaveAsPivot.id);
                PivotStore.getSavedAsPivot(userStore.user?.customerName!);
                setTimeout(() => {
                  history('/dashboard');
                }, 1000);
              }}
            >
              Delete
            </Button>
          </Button.Group>
          <div style={{ marginTop: '40px' }}>
            <PivotTablejs
              activitiesByDate={mainPivotData2}
              setPivotRowandColumn={setPivotRowandColumn2}
              rows={pivotRow2}
              cols={pivotColumn2}
              redirectData={(myId: string) => history(`/mediaAssets/${myId}`)}
              chosenPivotReportKeysSingle={chosenPivotReportKeysSingle}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default observer(SaveAsPivot);
